import { PostHogProvider } from '@posthog/react'
import posthog from 'posthog-js'
import type { PropsWithChildren } from 'react'

import { startAnalytics } from './config'
import { restoreJourneyId } from './journey'

// Initialised at module load, BEFORE React mounts — the same reasoning as the
// `clientMain.setConfig` call in `App.tsx`. Deferring to an effect loses the
// first `$pageview` of the session, which is the top of the signup funnel, and
// makes StrictMode's double invocation something to defend against instead of
// something that cannot happen.
startAnalytics()

// Re-attaches `journey_id` as a super property for a journey already in
// progress. Does not mint one: someone who is not onboarding must not acquire a
// journey just by loading the app.
restoreJourneyId()

/**
 * Hosts the PostHog client for the whole app tree. Mount ONCE, in `App.tsx`.
 *
 * Passes `client` rather than `apiKey`, because the init and its
 * "is a key even set?" guard belong to `config.ts` — handing the provider a key
 * would have it initialise unconditionally.
 *
 * Safe to render when unconfigured: the client is simply never initialised, and
 * every helper in this folder no-ops.
 */
export const AnalyticsProvider = ({ children }: PropsWithChildren) => (
  <PostHogProvider client={posthog}>{children}</PostHogProvider>
)
